import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import * as ROUTES from '../constants/routes';
import { withFirebase } from './Firebase';
import './SignUpPage.css';
import PropTypes from 'prop-types';
import userProfilImage from './assets/icon_user_profile.svg';
import Background from "./assets/login_background.svg"
import uuid from 'uuid/v1';
import BackgroundMobile from "./assets/login_background_mobile.svg";
import { CircularProgress, withStyles } from '@material-ui/core';
import { invalid } from 'moment';


class SignUp extends Component {
    render() {
        let width = window.innerWidth;
        if (width > 768) {
            return (
                <div className="custom-background">
                    <SignUpForm />
                </div>)
        } else {
            return (
                <div className="custom-background">
                    <SignUpFormPhone />
                    {this.props.children}
                </div>
            )
        }
    }
}

const INITIAL_STATE = {
    username: '',
    lastname: '',
    firstname: '',
    email: '',
    passwordOne: '',
    manager: '',
    error: null,
    errorMessage: null,
    companies: [],
    selectedCompanyName: '',
    selectedCompanyLogo: '',
    showCity: false,
    showUsers: false,
    allCity: [],
    city: '',
    users: [],
    currentsUsers: [],
    image_url: null,
    image: null,
    image_url_profile: null,
    select_manager: '',
    invitationManager: false,
    company: "",
    loading: false,
    managerInput: ''
};

const SIGN_UP_STATE = {
    USER_INFORMATIONS: 0,
    USER_MANAGER: 1
}

const SIGN_UP_SEARCH = {
    NO: 0,
    YES: 1
}

const style_selected_user = {
    background: 'rgba(75,153,222,0.25)'
};

class SignUpFormBase extends Component {
    constructor(props) {
        super(props);
        this.state = { ...INITIAL_STATE, currentState: SIGN_UP_STATE.USER_INFORMATIONS, };
        this.current_search = SIGN_UP_SEARCH.NO;
        this.handleChange = this.handleChange.bind(this)
    }


    componentDidMount() {
        document.body.style.background = `url(${Background}) no-repeat center fixed`;
        document.body.style.backgroundSize = "cover";
        this.props.firebase.db.collection('companies').get()
            .then(querySnapshot => {
                const companies = querySnapshot.docs.map(doc => doc)
                this.setState({
                    companies: companies
                })
            })
        this.props.firebase.db.collection('users').get()
            .then(querySnapshot => {
                const users = querySnapshot.docs.map(doc => doc)
                this.setState({
                    users: users
                })
            })
    }

    onSubmitUserInformations = event => {
        this.setState({ currentState: SIGN_UP_STATE.USER_MANAGER })
        event.preventDefault();
    }

    openInvitationManager = () => {
        this.setState({
            invitationManager: true
        })
    }

    closeInvitationManager = () => {
        this.setState({
            invitationManager: false
        })
    }

    onSubmitManager = async event => {
        event.preventDefault();
        let { firstname, lastname, company, email, manager, city, passwordOne, image } = this.state;
        this.setState({ error: null, loading: true })
        let url = null;
        let authUser = await this.props.firebase.doCreateUserWithEmailAndPassword(email, passwordOne).catch(error => {
            this.setState({ error, loading: false });
            switch (error.code) {
                case 'auth/uid-already-exists':
                    this.setState({ errorMessage: "Inscription échouée : e-mail déjà existant" })
                    break;
                case 'auth/email-already-exists':
                    this.setState({ errorMessage: "Inscription échouée : e-mail déjà existant" })
                    break
                case 'auth/email-already-in-use':
                    this.setState({ errorMessage: "Inscription échouée : e-mail déjà existant" })
                    break
                case 'auth/missing-uid':
                    this.setState({ errorMessage: "Inscription échouée : veuillez renseigner une adresse e-mail" })
                    break
                case 'auth/invalid-uid':
                    this.setState({ errorMessage: "Inscription échouée : l'identifiant est invalide" })
                    break
                default:
                    this.setState({ errorMessage: "Inscription échouée : Une erreur est survenue" })
            }
        });

        if (!this.state.error) {
            let id = authUser.user.uid

            if (manager === "") {
                manager = uuid()
            }

            if (image) {
                let imageUuid = uuid();
                await this.props.firebase.storage.ref(`images/${imageUuid}`).put(image)
                url = await this.props.firebase.storage.ref('images').child(imageUuid).getDownloadURL()
            }

            await this.props.firebase.user(id).set({ firstname, company, lastname, email, manager, city, image_url_profile: url })
                .catch(errors => {
                    this.setState({ error: errors, loading: false });
                })
            await this.props.firebase.doSendEmailVerification()

            this.setState({ loading: false })
        }

    }

    onChange = event => {
        if (event.target.name === "email") {
            let email = event.target.value
            let emailSuffix = email.replace(/.*@/, "");
            if (emailSuffix.length > 0) {
                let matchingCompanies = this.state.companies.filter(company => company.data().email_suffix === emailSuffix)
                if (matchingCompanies.length > 1) {
                    this.setState({ showCity: true, allCity: matchingCompanies, company: matchingCompanies[0].id, selectedCompanyName: matchingCompanies[0].data().name, selectedCompanyLogo: matchingCompanies[0].data().logo })
                } else if (matchingCompanies.length > 0) {
                    this.setState({
                        selectedCompanyName: matchingCompanies[0].data().name,
                        selectedCompanyLogo: matchingCompanies[0].data().logo,
                        company: matchingCompanies[0].id
                    })
                } else {
                    this.setState({
                        selectedCompanyName: '',
                        selectedCompanyLogo: '',
                        company: ''
                    })
                }
            }
            this.setState({ email: event.target.value })
        } else if (event.target.name === "manager") {
            this.setState({ currentsUsers: [], managerInput: event.target.value });
            let user = event.target.value;
            let matchingUsers = this.state.users.filter(userselect => (userselect.data().firstname + userselect.data().lastname).toLowerCase().includes(user.toLowerCase()) && userselect.data().company === this.state.company)
            if (matchingUsers.length > 0) {
                this.setState({ showUsers: true, currentsUsers: matchingUsers })
            }
            return
        }
        this.setState({ [event.target.name]: event.target.value });
    };

    onBack = () => {
        this.setState({ currentState: SIGN_UP_STATE.USER_INFORMATIONS });
    }

    onSelectCity = (event) => {
        this.setState({ city: event.target.value });
    }

    onTest = (event) => {
    }

    onBackSignIn = () => {
        this.props.history.push(ROUTES.SIGN_IN);
    }

    handleChange = e => {
        e.persist()
        if (e.target.files[0]) {
            const current_image = e.target.files[0];
            this.setState({ image_url: URL.createObjectURL(current_image), image: current_image });
        }
    }

    userInformationsForm = () => {
        const {
            firstname,
            lastname,
            email,
            passwordOne,
            error,
            errorMessage,
            selectedCompanyName,
            selectedCompanyLogo,
            showCity,
            allCity,
            image_url,
        } = this.state;

        const isInvalid =
            passwordOne === '' ||
            email === '' ||
            firstname === '' ||
            lastname === '' ||
            image_url === '';

        return (
            <div className="body-signup">
                <div className="vertical-center-row pt-5">
                    <div className="text-center mb-5">
                        <img onClick={this.onBackSignIn} className="cursor-pointer logo-img" src={require('../assets/loading/logo_zideeUp.png')} alt="logo"></img>
                        <div hidden={!(selectedCompanyName.length > 0)}>
                            <h1 className="title pt-4 pb-4">&</h1>
                            <img alt="select" className="picture-compagny-signup mr-2" src={selectedCompanyLogo}></img>
                            <span className="title-compagny">{selectedCompanyName}</span>
                        </div>
                    </div>
                </div>
                <div className="vertical-center-row ">
                    <div className="custom-form">
                        <form method="POST" onSubmit={this.onSubmitUserInformations}>
                            <div className="text-center pt-3">
                                <span>
                                    <label htmlFor="emplacements-import" className="import">
                                        <img className="profile_picture cursor-pointer" src={image_url !== null ? image_url : userProfilImage} alt="Importer" />
                                    </label>
                                    <input onChange={this.handleChange} hidden={true} id="emplacements-import" className="import" type="file" accept="image/*" />
                                    <h1 className="profile-font pt-2">Uploader une photo</h1>
                                </span>
                            </div>
                            <div className="form-group form-sign">
                                <label className="custom-label">Votre nom</label>
                                <input
                                    className="custom-input"
                                    name="lastname"
                                    value={lastname}
                                    onChange={this.onChange}
                                    type="text"
                                    placeholder="Nom" />
                            </div>
                            <div className="form-group form-sign">
                                <label className="custom-label">Votre prénom</label>
                                <input
                                    className="custom-input"
                                    name="firstname"
                                    value={firstname}
                                    onChange={this.onChange}
                                    type="text"
                                    placeholder="Prénom" />
                            </div>
                            <div className="form-group form-sign">
                                <label className="custom-label">Email</label>
                                <input
                                    className="custom-input"
                                    name="email"
                                    value={email}
                                    onChange={this.onChange}
                                    type="email"
                                    placeholder="email" />
                            </div>
                            <div hidden={!(showCity === true)} className="form-group">
                                <label className="custom-label">City</label>
                                <select onChange={this.onSelectCity}>
                                    {allCity.map((compani) => <option key={compani.city} value={compani.city}>{compani.city}</option>)}
                                </select>
                            </div>
                            <div className="form-group form-sign">
                                <label className="custom-label">Mot de passe</label>
                                <input
                                    className="custom-input"
                                    name="passwordOne"
                                    value={passwordOne}
                                    onChange={this.onChange}
                                    type="password"
                                    placeholder="Mot de passe" />
                            </div>
                            <div className="text-center">
                                <div hidden={!(selectedCompanyName.length > 0)}>
                                    <button className="custom-btn mb-3" disabled={isInvalid} type="submit">Suivant</button>
                                </div>
                                <div hidden={(selectedCompanyName.length > 0)}>
                                    <button className="custom-btn-grey  mb-3" disabled={true} >Suivant</button>
                                </div>
                            </div>
                            <div className="signup-error">
                                {error && <p>{errorMessage}</p>}
                            </div>

                        </form>
                    </div>
                </div>
            </div>
        )
    }

    test = (user) => {
        this.setState({ manager: user.id });
    }

    userManagerForm = () => {
        const {
            managerInput,
            showUsers,
            currentsUsers,
            selectedCompanyName,
            selectedCompanyLogo,
            error,
            errorMessage,
            loading,
            manager
        } = this.state;
        const context = this
        return (
            <div className="body-signup">
                <div className="vertical-center-row pt-5">
                    <div className="text-center mb-5">
                        <a href="/signup"><img
                            className="cursor-pointer logo-img"
                            src={require("../assets/loading/logo_zideeUp.png")}
                            alt="logo"
                        /></a>
                        <div hidden={!(selectedCompanyName.length > 0)}>
                            <h1 className="title pt-4 pb-4">&</h1>
                            <img className="picture-compagny-signup mr-2" src={selectedCompanyLogo} alt="company"></img>
                            <span className="title-compagny">{selectedCompanyName}</span>
                        </div>
                    </div>
                </div>
                <div className="vertical-center-row">
                    <div className="custom-form-manager">
                        <span onClick={this.onBack} className="carousel-control-prev-icon mt-3 custom-span cursor-pointer"></span>
                        <form method="post" onSubmit={this.onSubmitManager}>
                            <div className="custom-text-manager form-group mt-4">
                                <p className=" pl-2 custom-text-manager">Sélectionnez un responsable pour trouver votre constellation</p>
                                <input
                                    className="custom-input"
                                    name="manager"
                                    value={managerInput}
                                    onChange={this.onChange}
                                    type="text"
                                    placeholder="Recherche un email ou un nom"
                                />
                                <div hidden={!(showUsers === true)} className="form-group manager-selection">
                                    {currentsUsers.map((user) =>
                                        <div
                                            onClick={() => this.test(user)}
                                            className="manager mt-3 text-center"
                                            style={manager === user.id ? style_selected_user : {}}
                                        >
                                            <img
                                                className="picture-compagny"
                                                src={user.data().image_url_profile !== null ? user.data().image_url_profile : userProfilImage}
                                                onError={context.props.firebase.profileImgError}
                                                alt="company"
                                            ></img>
                                            <div className="container-manager-selection">
                                                <h3 key={user.data().firstname} value={user.data().firstname}>{user.data().firstname} {user.data().lastname}</h3>
                                                <span className="position-list">{user.data().position ? user.data().position : "Poste non renseigné"}</span>
                                            </div>
                                        </div>)}
                                </div>
                            </div>
                            <div className="text-center mt-5">
                                <p className="custom-text-manager mb-4">Vous ne trouvez-pas ? <a href={"mailto:"}>Envoyer une invitation</a></p>
                                <button
                                    className="custom-btn mt-2"
                                    disabled={!manager}
                                    type="submit"
                                >
                                    Suivant

                                </button>
                            </div>
                            {loading && <div class="center mt-1"> <CircularProgress className={this.props.classes.progress}></CircularProgress></div>}
                            <div className="signup-error">
                                {error && <p>{errorMessage}</p>}
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        )
    }

    render() {
        const {
            currentState,
        } = this.state;

        return (
            <>
                {currentState === SIGN_UP_STATE.USER_INFORMATIONS ? (this.userInformationsForm()) : (this.userManagerForm())}
            </>
        );
    }
}


class SignUpFormBasePhone extends Component {
    constructor(props) {
        super(props);
        this.state = { ...INITIAL_STATE, currentState: SIGN_UP_STATE.USER_INFORMATIONS, };
        this.current_search = SIGN_UP_SEARCH.NO;
        this.handleChange = this.handleChange.bind(this)
    }


    componentDidMount() {
        document.body.style.background = `url(${BackgroundMobile}) no-repeat center fixed`;
        document.body.style.backgroundSize = "cover";
        this.props.firebase.db.collection('companies').get()
            .then(querySnapshot => {
                const companies = querySnapshot.docs.map(doc => doc)
                this.setState({
                    companies: companies
                })
            })
        this.props.firebase.db.collection('users').get()
            .then(querySnapshot => {
                const users = querySnapshot.docs.map(doc => doc)
                this.setState({
                    users: users
                })
            })
    }

    onSubmitUserInformations = event => {
        this.setState({ currentState: SIGN_UP_STATE.USER_MANAGER })
        event.preventDefault();
    }

    onSubmitManager = async event => {
        event.preventDefault();
        let { firstname, lastname, company, email, manager, city, passwordOne, image } = this.state;
        this.setState({ error: null })
        let url = null;
        let authUser = await this.props.firebase.doCreateUserWithEmailAndPassword(email, passwordOne).catch(error => {
            console.error(error)
            this.setState({ error });
            switch (error.code) {
                case 'auth/uid-already-exists':
                    this.setState({ errorMessage: "Inscription échouée : e-mail déjà existant" })
                    break;
                case 'auth/email-already-exists':
                    this.setState({ errorMessage: "Inscription échouée : e-mail déjà existant" })
                    break
                case 'auth/email-already-in-use':
                    this.setState({ errorMessage: "Inscription échouée : e-mail déjà existant" })
                    break
                case 'auth/missing-uid':
                    this.setState({ errorMessage: "Inscription échouée : veuillez renseigner une adresse e-mail" })
                    break
                case 'auth/invalid-uid':
                    this.setState({ errorMessage: "Inscription échouée : l'identifiant est invalide" })
                    break
                default:
                    this.setState({ errorMessage: "Inscription échouée : Une erreur est survenue" })
            }
        });

        if (!this.state.error) {
            let id = authUser.user.uid

            if (manager === "") {
                manager = uuid()
            }

            if (image) {
                let imageUuid = uuid();
                await this.props.firebase.storage.ref(`images/${imageUuid}`).put(image)
                url = await this.props.firebase.storage.ref('images').child(imageUuid).getDownloadURL()
            }

            await this.props.firebase.user(id).set({ firstname, company, lastname, email, manager, city, image_url_profile: url })
                .catch(errors => {
                    this.setState({ error: errors });
                })
            await this.props.firebase.doSendEmailVerification()
        }
    }

    onChange = event => {
        if (event.target.name === "email") {
            let email = event.target.value
            let emailSuffix = email.replace(/.*@/, "");
            if (emailSuffix.length > 0) {
                let matchingCompanies = this.state.companies.filter(company => company.data().email_suffix === emailSuffix)
                if (matchingCompanies.length > 1) {
                    this.setState({ showCity: true, allCity: matchingCompanies, company: matchingCompanies[0].id, selectedCompanyName: matchingCompanies[0].data().name, selectedCompanyLogo: matchingCompanies[0].data().logo })
                } else if (matchingCompanies.length > 0) {
                    this.setState({
                        selectedCompanyName: matchingCompanies[0].data().name,
                        selectedCompanyLogo: matchingCompanies[0].data().logo,
                        company: matchingCompanies[0].id,
                    })
                }
            }
        } else if (event.target.name === "manager") {
            this.setState({ currentsUsers: [], managerInput: event.target.value });
            let user = event.target.value;
            let matchingUsers = this.state.users.filter(userselect => (userselect.data().firstname + userselect.data().lastname).toLowerCase().includes(user.toLowerCase()) && userselect.data().company === this.state.company)
            if (matchingUsers.length > 0) {
                this.setState({ showUsers: true, currentsUsers: matchingUsers })
            }
            return
        }
        this.setState({ [event.target.name]: event.target.value });
    };

    onBack = () => {
        this.setState({ currentState: SIGN_UP_STATE.USER_INFORMATIONS });
    }

    onBackSignIn = () => {
        this.props.history.push(ROUTES.SIGN_IN);
    }

    onSelectCity = (event) => {
        this.setState({ city: event.target.value });
    }

    onTest = (event) => {
    }

    handleChange = e => {
        e.persist()
        if (e.target.files[0]) {
            const current_image = e.target.files[0];
            this.setState({ image_url: URL.createObjectURL(current_image), image: current_image });
        }
    }


    userInformationsForm = () => {
        const {
            firstname,
            lastname,
            email,
            passwordOne,
            error,
            errorMessage,
            selectedCompanyName,
            selectedCompanyLogo,
            showCity,
            allCity,
            image_url,
        } = this.state;

        const isInvalid =
            passwordOne === '' ||
            email === '' ||
            firstname === '' ||
            lastname === '' ||
            image_url === '';
        return (
            <div className="body-signup">
                <div className="toolbar-signup">
                    <span onClick={this.onBackSignIn} className="carousel-control-prev-icon mt-3 custom-span "></span>
                </div>
                <div className="row vertical-center-row pt-5">
                    <div className="col text-center mb-5">
                        <img src={require('../assets/loading/logo_zideeUp.png')} className="logo-img-mobile" alt="logo"></img>
                        <div hidden={!(selectedCompanyName.length > 0)}>
                            <h1 className="title pt-2 pb-1">&</h1>
                            <img alt="company" className="picture-compagny-signup mr-2" src={selectedCompanyLogo}></img>
                            <span className="title-compagny">{selectedCompanyName}</span>
                        </div>
                    </div>
                </div>
                <div className="row vertical-center-row">
                    <div className="col">
                        <form onSubmit={this.onSubmitUserInformations} method="POST">
                            <div className="text-center pt-3">
                                <span>
                                    <label htmlFor="emplacements-import" className="import">
                                        <img className="profile_picture" src={image_url !== null ? image_url : userProfilImage} alt="Importer" />
                                    </label>
                                    <input onChange={this.handleChange} hidden={true} id="emplacements-import" className="import" type="file" />
                                    <h1 className="profile-font pt-2">Uploader une photo</h1>
                                </span>
                            </div>
                            <div className="form-group">
                                <label className="custom-label-phone">Votre nom</label>
                                <div className="text-center">
                                    <input
                                        className="custom-input"
                                        name="lastname"
                                        value={lastname}
                                        onChange={this.onChange}
                                        type="text"
                                        placeholder="Nom" />
                                </div>
                            </div>
                            <div className="form-group">
                                <label className="custom-label-phone">Votre prénom</label>
                                <div className="text-center">
                                    <input
                                        className="custom-input"
                                        name="firstname"
                                        value={firstname}
                                        onChange={this.onChange}
                                        type="text"
                                        placeholder="Prénom" />
                                </div>
                            </div>
                            <div className="form-group">
                                <label className="custom-label-phone">Email</label>
                                <div className="text-center">
                                    <input
                                        className="custom-input"
                                        name="email"
                                        value={email}
                                        onChange={this.onChange}
                                        type="email"
                                        placeholder="email" />
                                </div>
                            </div>
                            <div hidden={!(showCity === true)} className="form-group">
                                <label>City</label>
                                <select className="text-center" onChange={this.onSelectCity}>
                                    {allCity.map((compani) => <option key={compani.city} value={compani.city}>{compani.city}</option>)}
                                </select>
                            </div>
                            <div className="form-group">
                                <label className="custom-label-phone">Mot de passe</label>
                                <div className="text-center">
                                    <input
                                        className="custom-input"
                                        name="passwordOne"
                                        value={passwordOne}
                                        onChange={this.onChange}
                                        type="password"
                                        placeholder="Mot de passe" />
                                </div>
                            </div>
                            <div className="text-center">
                                <div hidden={!(selectedCompanyName.length > 0)}>
                                    <button className="custom-btn mb-3" disabled={isInvalid} type="submit">Suivant</button>
                                </div>
                                <div hidden={(selectedCompanyName.length > 0)}>
                                    <button className="custom-btn-grey  mb-3" disabled={true} >Suivant</button>
                                </div>
                            </div>
                            <div className="signup-error">
                                {error && <p>{errorMessage}</p>}
                            </div>

                        </form>
                    </div>
                </div>
            </div>
        )
    }

    test = (user) => {
        this.setState({ select_manager: (user.data().firstname + ' ' + user.data().lastname), manager: user.id });
    }

    userManagerForm = () => {
        const {
            managerInput,
            manager,
            showUsers,
            currentsUsers,
            error,
            errorMessage,
            selectedCompanyName,
            selectedCompanyLogo,
        } = this.state;
        const context = this;
        return (
            <div className="body-signup">
                <div className="toolbar-signup">
                    <span onClick={this.onBack} className="carousel-control-prev-icon mt-3 custom-span "></span>
                </div>
                <div className="row vertical-center-row pt-5">
                    <div className="col text-center mb-5">
                        <img
                            src={require("../assets/loading/logo_zideeUp.png")}
                            className="logo-img-mobile"
                            alt="logo"
                        />
                        <div hidden={!(selectedCompanyName.length > 0)}>
                            <h1 className="title pt-2 pb-1">&</h1>
                            <img alt="company" className="picture-compagny-signup mr-2" src={selectedCompanyLogo}></img>
                            <span className="title-compagny">{selectedCompanyName}</span>
                        </div>
                    </div>
                </div>
                <div className="row vertical-center-row">
                    <div className="col custom-form-manager-phone no-padding">
                        <div className="col">
                            <form className="text-center" onSubmit={this.onSubmitManager}>
                                <div className="custom-text-manager form-group mt-3">
                                    <p className=" pl-2 custom-text-manager">Sélectionnez un responsable pour trouver votre constellation</p>
                                    <input
                                        className="custom-input"
                                        name="manager"
                                        value={managerInput}
                                        onChange={this.onChange}
                                        type="text"
                                        placeholder="Recherche un email ou un nom"
                                    />
                                    <div hidden={!(showUsers === true)} className="form-group manager-selection-phone">
                                        {currentsUsers.map((user) => <div
                                            onClick={() => this.test(user)}
                                            className="manager mt-3 text-center"
                                            style={manager === user.id ? style_selected_user : {}}>
                                            <img alt="company"
                                                className="picture-compagny"
                                                src={user.data().image_url_profile !== null ? user.data().image_url_profile : userProfilImage}
                                                onError={context.props.firebase.profileImgError}
                                            ></img>
                                            <div className="container-manager-selection">
                                                <h3 key={user.data().firstname} value={user.data().firstname}>{user.data().firstname} {user.data().lastname}</h3>
                                                <span className="position-list">{user.data().position ? user.data().position : "Poste non renseigné"}</span>
                                            </div>
                                        </div>)}
                                    </div>
                                </div>
                                <div className="text-center mt-5">
                                    <p className="custom-text-manager mb-4">Vous ne trouvez-pas ? <a href={"mailto:"}>Envoyer une invitation</a></p>
                                    <button
                                        className="custom-btn mt-2"
                                        disabled={!manager}
                                        type="submit"
                                    >
                                        Suivant
                        </button>
                                </div>
                                <div className="signup-error">
                                    {error && <p>{errorMessage}</p>}
                                </div>

                            </form>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    render() {
        const {
            currentState,
        } = this.state;

        return (
            <>
                {currentState === SIGN_UP_STATE.USER_INFORMATIONS ? (this.userInformationsForm()) : (this.userManagerForm())}
            </>
        );
    }
}

const styles_loader = theme => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    progress: {
        color: '#FFFFFF',
        marginTop: '10px',
        marginLeft: 'auto',
        marginRight: 'auto'
    },
});

SignUpFormBase.propTypes = {
    classes: PropTypes.object.isRequired,
};

SignUpFormBasePhone.propTypes = {
    classes: PropTypes.object.isRequired,
}

const SignUpForm = withRouter(withFirebase(withStyles(styles_loader)(SignUpFormBase)));
const SignUpFormPhone = withRouter(withFirebase(withStyles(styles_loader)(SignUpFormBasePhone)));

export default SignUp;
export { SignUpForm, SignUpFormPhone };
